// extracted by mini-css-extract-plugin
export default {"root":"_6Wq0z","left":"_2HuVi","right":"_3D_F_"};